import { useState } from "react";

import { useSelector } from "react-redux";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, confirmHeader = "Delete Confirmation", confirmText = "Are you sure you want to delete this item? This action cannot be undone." }) => {
    const { cancelLoading } = useSelector((state) => state.payments);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/40">
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-sm p-6">
                <h2 className="text-lg font-semibold text-gray-800">
                    {confirmHeader}
                </h2>
                <p className="text-sm text-gray-600 mt-2">
                    {confirmText}
                </p>

                <div className="flex justify-end gap-3 mt-6">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 flex items-center gap-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
                    >
                        {cancelLoading && <div className="w-4 h-4 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>}
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}

export default DeleteConfirmModal;
